import _ from "lodash";
import i18n from "translations/i18n";
import { DELIVERY_OPTIONS } from "constants/DeliveryConstants";
import { VARIATION_PIECES, VARIATION_WEIGHT } from "constants/VariationConstant";
import moment from "moment";
import { order_invoice } from "../urls";
import { findCategoryById, findMainCategoryBySubId } from "./categories";

export const getPickListData = function (data, allProducts, vceProducts, categories) {
  let uniqueProducts = [];
  data.map((order) => {
    // Aggregate identical products WITHIN this order first, so per-order totals are merged
    const perOrderMap = {};

    const makeKey = (name, type, weight) => `${name}|${type || "_"}|${weight ?? "_"}`;

    const addToPerOrder = (entry) => {
      const key = makeKey(entry.name, entry.type, entry.weight);
      if (!perOrderMap[key]) {
        perOrderMap[key] = { ...entry, amountPerOrder: [] };
      } else {
        perOrderMap[key].quantity += entry.quantity;
      }
    };

    order.products.map((product) => {
      const searchProducts = order.isVleescentrum ? vceProducts : allProducts;
      let currentProduct = _.find(searchProducts, ["id", product.productId]);
      let productList = !!currentProduct && currentProduct.productItems ? currentProduct.productItems : null;
      if (order.orderId === "HVC-9965-741367-9056") {
        console.log("kapotte order: ", order);
        console.log("product: ", product);
        console.log("productList: ", productList);
      }

      const resolveCategory = (prod) => {
        let category;
        if (!prod) return "Verwijderde categorie";
        if (prod.categories) {
          let foundCategory = findCategoryById(categories, prod.categories[0]);
          if (!foundCategory) {
            if (product.categories[0] === "b21a5027-b7e6-456f-9212-34bc799c0acc") category = "Rundvlees";
            else if (product.categories[0] === "2607f2ee-3906-46d0-ad1b-8c10998220f7")
              category = "Kruiden en specerijen";
            else if (product.categories[0] === "a3cfad66-005a-4fb1-9a2f-71c1203748b7") category = "Kip lekker";
            else if (product.categories[0] === "d462b4d7-7f87-43bd-aed7-48a00a891b41") category = "Vleeswaren";
            else if (product.categories[0] === "fd61c041-cb50-46fa-b897-4d9bdf88ae62") category = "Lamsvlees";
            else if (product.categories[0] === "1af8ae89-be8a-42af-8471-037022574304") category = "Kalfsvlees";
            else if (product.categories[0] === "69d2e9b8-22ed-4c59-aad5-e11d81fa6ab4") category = "Snacks";
            else if (product.categories[0] === "65071f0a-92d1-4a42-a914-f18d5118e67f") category = "Sauzen en diversen";
            else if (product.categories[0] === "0bd28957-e9f3-4ac5-b29b-a1117c06b4f6") category = "Vis en vega";
            else if (product.categories[0] === "c19c7f17-7392-477f-bc46-b16268bc2362") category = "Premium rundvlees";
            else if (product.categories[0] === "7196ee10-378f-423c-9e8b-d65ebc4f0377") category = "Vleespakketten";
            else if (product.categories[0] === "0df50dfa-4d3e-4695-b798-9ee491ca9226") category = "Kip en gevogelte";
            else if (product.categories[0] === "829dd2c6-f1e9-4570-a454-3650304fc05a") category = "Barbecue";
            else if (product.categories[0] === "e2ff3411-bb0f-4708-ba7c-ed09e4ca81b9") category = "Barbecue";
            else category = "Verwijderde categorie";
          } else category = foundCategory.name;
          if (!!foundCategory && foundCategory.subcategoryId) {
            let mainCategory = findMainCategoryBySubId(categories, foundCategory.subcategoryId);
            category = mainCategory?.name || "Verwijderde categorie";
          }
        } else {
          if (typeof prod.category === "object") {
            category = prod.category[0];
          } else {
            let foundCategory = findCategoryById(categories, prod.category);
            if (!foundCategory) {
              if (product.categories[0] === "b21a5027-b7e6-456f-9212-34bc799c0acc") category = "Rundvlees";
              else if (product.categories[0] === "2607f2ee-3906-46d0-ad1b-8c10998220f7")
                category = "Kruiden en specerijen";
              else if (product.categories[0] === "a3cfad66-005a-4fb1-9a2f-71c1203748b7") category = "Kip lekker";
              else if (product.categories[0] === "d462b4d7-7f87-43bd-aed7-48a00a891b41") category = "Vleeswaren";
              else if (product.categories[0] === "fd61c041-cb50-46fa-b897-4d9bdf88ae62") category = "Lamsvlees";
              else if (product.categories[0] === "1af8ae89-be8a-42af-8471-037022574304") category = "Kalfsvlees";
              else if (product.categories[0] === "69d2e9b8-22ed-4c59-aad5-e11d81fa6ab4") category = "Snacks";
              else if (product.categories[0] === "65071f0a-92d1-4a42-a914-f18d5118e67f")
                category = "Sauzen en diversen";
              else if (product.categories[0] === "0bd28957-e9f3-4ac5-b29b-a1117c06b4f6") category = "Vis en vega";
              else if (product.categories[0] === "c19c7f17-7392-477f-bc46-b16268bc2362") category = "Premium rundvlees";
              else if (product.categories[0] === "7196ee10-378f-423c-9e8b-d65ebc4f0377") category = "Vleespakketten";
              else if (product.categories[0] === "0df50dfa-4d3e-4695-b798-9ee491ca9226") category = "Kip en gevogelte";
              else if (product.categories[0] === "829dd2c6-f1e9-4570-a454-3650304fc05a") category = "Barbecue";
              else if (product.categories[0] === "e2ff3411-bb0f-4708-ba7c-ed09e4ca81b9") category = "Barbecue";
              else category = "Verwijderde categorie";
            } else category = foundCategory.name;
            if (category?.subcategoryId) {
              let foundMain = findMainCategoryBySubId(categories, category.subcategoryId);
              category = foundMain?.name || "Verwijderde categorie";
            }
          }
        }
        return category;
      };

      if (!!productList) {
        productList.map((item, index) => {
          let productById = _.find(searchProducts, ["id", item.productId]);
          if (!product.giftCard) {
            const category = resolveCategory(productById);
            const quantity =
              item.type === VARIATION_PIECES
                ? product.quantity * item.value
                : item.type === VARIATION_WEIGHT
                  ? product.quantity * (item.quantity || 1)
                  : product.quantity;
            const weight = item.type === VARIATION_WEIGHT ? item.value : null;
            addToPerOrder({
              key: productById.id + index,
              name: productById.name,
              type: null,
              quantity,
              weight,
              amountPerOrder: [],
              category,
            });
          }
        });
      } else {
        if (!product.giftCard) {
          const category = resolveCategory(product);
          addToPerOrder({
            key: product.variantId,
            name: product.type ? product.name + " (" + product.type + ")" : product.name,
            type: product.type,
            quantity: product.quantity,
            weight: product.variation && product.variation.weight ? product.variation.weight : null,
            amountPerOrder: [],
            category,
          });
        }
      }
    });

    // Now merge this order's aggregated products into the global uniqueProducts,
    // pushing a SINGLE per-order total into amountPerOrder
    Object.values(perOrderMap).map((product) => {
      let uniqueProductIndex = _.findIndex(uniqueProducts, (o) => {
        if (product.type && product.weight)
          return o.type === product.type && o.weight === product.weight && o.name === product.name;
        else if (!product.type && product.weight) return o.weight === product.weight && o.name === product.name;
        else if (product.type && !product.weight) {
          return o.name === product.name;
        } else if (!product.type && !product.weight) return o.name === product.name;
      });
      if (uniqueProductIndex < 0) {
        uniqueProducts.push({
          ...product,
          amountPerOrder: [product.quantity],
        });
      } else {
        uniqueProducts[uniqueProductIndex].quantity += product.quantity;
        uniqueProducts[uniqueProductIndex].amountPerOrder.push(product.quantity);
      }
    });
  });

  return _.sortBy(uniqueProducts, (product) => product.category);
};

// export const getPickListData = function (data, allProducts, categories) {
//   let uniqueProducts = [];
//   data.map((order) => {
//     // Create array that will contain all product objects
//     let products = [];
//     order.products.map((product) => {
//       let currentProduct = _.find(allProducts, ["id", product.productId]);
//
//       let productList = !!currentProduct && currentProduct.productItems ? currentProduct.productItems : null;
//
//       // If product contains a list of other products, we need those individual items in the picklist
//       if (!!productList) {
//         // For every item in the productList, push every individual product into the products array
//         productList.map((item, index) => {
//           let productById = _.find(allProducts, ["id", item.productId]);
//           let category;
//           if (productById.categories) {
//             let foundCategory = findCategoryById(categories, productById.categories[0]);
//             if (!foundCategory) {
//               if (product.categories[0] === "b21a5027-b7e6-456f-9212-34bc799c0acc") category = "Rundvlees";
//               else if (product.categories[0] === "2607f2ee-3906-46d0-ad1b-8c10998220f7")
//                 category = "Kruiden en specerijen";
//               else if (product.categories[0] === "a3cfad66-005a-4fb1-9a2f-71c1203748b7") category = "Kip lekker";
//               else if (product.categories[0] === "d462b4d7-7f87-43bd-aed7-48a00a891b41") category = "Vleeswaren";
//               else if (product.categories[0] === "fd61c041-cb50-46fa-b897-4d9bdf88ae62") category = "Lamsvlees";
//               else if (product.categories[0] === "1af8ae89-be8a-42af-8471-037022574304") category = "Kalfsvlees";
//               else if (product.categories[0] === "69d2e9b8-22ed-4c59-aad5-e11d81fa6ab4") category = "Snacks";
//               else if (product.categories[0] === "65071f0a-92d1-4a42-a914-f18d5118e67f")
//                 category = "Sauzen en diversen";
//               else if (product.categories[0] === "0bd28957-e9f3-4ac5-b29b-a1117c06b4f6") category = "Vis en vega";
//               else if (product.categories[0] === "c19c7f17-7392-477f-bc46-b16268bc2362") category = "Premium rundvlees";
//               else if (product.categories[0] === "7196ee10-378f-423c-9e8b-d65ebc4f0377") category = "Vleespakketten";
//               else if (product.categories[0] === "0df50dfa-4d3e-4695-b798-9ee491ca9226") category = "Kip en gevogelte";
//               else if (product.categories[0] === "829dd2c6-f1e9-4570-a454-3650304fc05a") category = "Barbecue";
//               else category = "Verwijderde categorie";
//             } else category = foundCategory.name;
//             if (!!foundCategory && foundCategory.subcategoryId) {
//               let mainCategory = findMainCategoryBySubId(categories, foundCategory.subcategoryId);
//               category = mainCategory.name;
//             }
//           } else {
//             if (typeof productById.category === "object") {
//               category = productById.category[0];
//             } else {
//               let foundCategory = findCategoryById(categories, productById.category);
//               if (!foundCategory) {
//                 category = "Verwijderde categorie";
//               } else category = foundCategory?.name;
//               if (category?.subcategoryId) {
//                 let foundCategory = findMainCategoryBySubId(categories, category.subcategoryId);
//                 if (!foundCategory) category = "Verwijderde categorie";
//                 else category = foundCategory?.name;
//               }
//             }
//           }
//           if (!product.giftCard)
//             products.push({
//               key: productById.id + index,
//               name: productById.name,
//               type: null,
//               quantity: item.type === VARIATION_PIECES ? product.quantity * item.value : product.quantity,
//               weight: item.type === VARIATION_WEIGHT ? item.value : null,
//               amountPerOrder: item.type === VARIATION_PIECES ? [product.quantity * item.value] : [product.quantity],
//               category: category.trim(),
//             });
//         });
//       } else {
//         let category;
//         if (product.categories) {
//           let foundCategory = findCategoryById(categories, product.categories[0]);
//           if (!foundCategory) {
//             if (product.categories[0] === "b21a5027-b7e6-456f-9212-34bc799c0acc") category = "Rundvlees";
//             else if (product.categories[0] === "2607f2ee-3906-46d0-ad1b-8c10998220f7")
//               category = "Kruiden en specerijen";
//             else if (product.categories[0] === "a3cfad66-005a-4fb1-9a2f-71c1203748b7") category = "Kip lekker";
//             else if (product.categories[0] === "d462b4d7-7f87-43bd-aed7-48a00a891b41") category = "Vleeswaren";
//             else if (product.categories[0] === "fd61c041-cb50-46fa-b897-4d9bdf88ae62") category = "Lamsvlees";
//             else if (product.categories[0] === "1af8ae89-be8a-42af-8471-037022574304") category = "Kalfsvlees";
//             else if (product.categories[0] === "69d2e9b8-22ed-4c59-aad5-e11d81fa6ab4") category = "Snacks";
//             else if (product.categories[0] === "65071f0a-92d1-4a42-a914-f18d5118e67f") category = "Sauzen en diversen";
//             else if (product.categories[0] === "0bd28957-e9f3-4ac5-b29b-a1117c06b4f6") category = "Vis en vega";
//             else if (product.categories[0] === "c19c7f17-7392-477f-bc46-b16268bc2362") category = "Premium rundvlees";
//             else if (product.categories[0] === "7196ee10-378f-423c-9e8b-d65ebc4f0377") category = "Vleespakketten";
//             else if (product.categories[0] === "0df50dfa-4d3e-4695-b798-9ee491ca9226") category = "Kip en gevogelte";
//             else if (product.categories[0] === "829dd2c6-f1e9-4570-a454-3650304fc05a") category = "Barbecue";
//             else category = "Verwijderde categorie";
//           } else category = foundCategory.name;
//           if (!!foundCategory && foundCategory.subcategoryId && typeof foundCategory.subcategoryId === "string") {
//             let mainCategory = findMainCategoryBySubId(categories, foundCategory.subcategoryId);
//             category = mainCategory?.name || "Verwijderde categorie";
//           }
//         } else {
//           if (typeof product.category === "object") {
//             category = product.category[0];
//           } else {
//             let foundCategory = findCategoryById(categories, product.category);
//             if (!foundCategory) category = "Verwijderde categorie";
//             else {
//               category = foundCategory.name;
//               if (category.subcategoryId) {
//                 let foundCategory = findMainCategoryBySubId(categories, category.subcategoryId);
//                 category = foundCategory?.name || "Verwijderde categorie";
//               }
//             }
//           }
//         }
//         // Product does not contain a productList, so just put the product into the products array;
//         if (!product.giftCard)
//           products.push({
//             key: product.variantId,
//             name: product.type ? product.name + " (" + product.type + ")" : product.name,
//             type: product.type,
//             quantity: product.quantity,
//             weight: product.variation && product.variation.weight ? product.variation.weight : null,
//             amountPerOrder: [product.quantity],
//             category: category.trim(),
//           });
//       }
//     });
//
//     products.map((product) => {
//       // For every product, check if it exists in the uniqueProducts array
//       // Check for type, weight and name.
//       // If it exists, increment the product based on quantity, if not add it to the array
//       let uniqueProductIndex = _.findIndex(uniqueProducts, (o) => {
//         if (product.type && product.weight)
//           return o.type === product.type && o.weight === product.weight && o.name === product.name;
//         else if (!product.type && product.weight) return o.weight === product.weight && o.name === product.name;
//         else if (product.type && !product.weight) {
//           return o.name === product.name;
//         } else if (!product.type && !product.weight) return o.name === product.name;
//       });
//       if (uniqueProductIndex < 0) {
//         uniqueProducts.push(product);
//       } else {
//         uniqueProducts[uniqueProductIndex].quantity += product.quantity;
//         uniqueProducts[uniqueProductIndex].amountPerOrder.push(product.quantity);
//       }
//     });
//   });
//
//   return _.sortBy(uniqueProducts, (product) => product.category);
// };

export const getSendListData = function (data) {
  let array = [];
  data.map((order) => {
    let customer = order.customer;
    let deliveryAddress = customer.address.delivery;
    let obj = {
      name: customer.firstName + " " + customer.lastName,
      street_and_number:
        deliveryAddress.street +
        " " +
        deliveryAddress.houseNumber +
        (!!deliveryAddress.addition ? deliveryAddress.addition : ""),
      zipcode_and_city: deliveryAddress.zipCode + " " + deliveryAddress.city,
      phone: customer.phoneNumber,
      deliveryType: order.delivery.type === DELIVERY_OPTIONS.SEND ? i18n.t("shipping") : i18n.t("pickup"),
      deliveryDate: order.delivery.date,
      orderId: order.orderId,
      orderNotes: order.orderNotes,
      isVleescentrum: order.isVleescentrum,
      frozen: order.delivery.frozen,
    };
    if (!order.containsOnlyGiftCards) array.push(obj);
  });
  return array;
};

/**
 * Get dates to disable for the datepicker
 * @param {*} current Current day in DatePicker
 * @param {*} deliveryType Delivery type selected by user
 * @returns
 */
export const getDisabledDatesForDatePicker = (current, deliveryType) => {
  let today = moment();
  let todayIndex = parseInt(moment(today).format("d"));
  let FRIDAY = 5;
  let SATURDAY = 6;
  let SUNDAY = 0;
  let MONDAY = 1;
  let excludeOffDays;

  if (deliveryType === DELIVERY_OPTIONS.SEND) {
    excludeOffDays =
      parseInt(moment(current).format("d")) === SATURDAY ||
      parseInt(moment(current).format("d")) === SUNDAY ||
      parseInt(moment(current).format("d")) === MONDAY;
  } else if (deliveryType === DELIVERY_OPTIONS.PICKUP) {
    excludeOffDays =
      parseInt(moment(current).format("d")) === SUNDAY || parseInt(moment(current).format("d")) === MONDAY;
  }

  if (todayIndex === FRIDAY) {
    if (deliveryType === DELIVERY_OPTIONS.SEND) {
      return moment(today).add(2, "days") >= current || excludeOffDays;
    } else if (deliveryType === DELIVERY_OPTIONS.PICKUP) {
      return moment(today).add(0, "days") >= current || excludeOffDays;
    }
  }

  if (todayIndex === SATURDAY) return moment(today).add(2, "days") >= current || excludeOffDays;
  else if (todayIndex === SUNDAY) return moment(today).add(1, "days") >= current || excludeOffDays;
  else return excludeOffDays;
};

/**
 * Generate invoice based on the order
 * @param order
 * @returns confirmation response
 */
export function generateInvoice(order) {
  return new Promise(function (resolve, reject) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(order),
    };
    fetch(order_invoice, requestOptions)
      .then((invoice) => resolve(invoice))
      .catch((error) => reject(error));
  });
}
